module.exports = __webpack_public_path__ + "img/simran.daafbd11.jpg";